import { Nil } from "../types";

type ReplacementMap = { [key: string]: string | number | Nil };

/**
 * Replaces placeholders in a string with corresponding values from an object.
 * Placeholders are defined as keys within curly braces in the string, e.g., "Hello {name}"
 *
 * @param str - The string with placeholders
 * @param values - An object with keys that correspond to the placeholders in the string
 * @returns - The resulting string with placeholders replaced by actual values
 *
 * **Example:**
 * `replacePlaceholders("Last {days} days", { days: 60 });`
 * => Should log: "Last 60 days"
 *
 */
export const replacePlaceholders = (str: string, values: ReplacementMap): string => {
  return str.replace(/{(\w+)}/g, (match, key) => {
    const value = values[key];
    return typeof value !== "undefined" ? String(value) : match;
  });
};
